import rpc from "@/src/rpc"
import { useRef, useState } from "react"
import Toggle from "./Toggle"
import useHighlight from "@/src/useHighlight"
import useRpc from "@/src/useRpc"
import WarningIcon from "./icons/WarningIcon"
import { sendMessage } from "@/src/useMessage"


export default function NotificationSettings () {

  const [user, _, reload] = useRpc('users.me')
  const [testEmailBusy, setTestEmailBusy] = useState(false)

  const statusRef = useRef(null)
  useHighlight('status', statusRef)

  const marketingRef = useRef(null)
  useHighlight('marketing', marketingRef)

  async function toggleNotification (type) {
    await rpc('users.toggleNotification', {type})
    await reload()
  }

  async function sendTestEmail () {
    if (testEmailBusy) return
    setTestEmailBusy(true)
    try {
      const result = await rpc('users.sendTestEmail', {userId: user.id})
      await reload()

      if (result.success) {
        sendMessage('alert', result.message)
      } else {
        sendMessage('error', result.message)
      }
    } catch (err) {
      sendMessage('error', 'Error unblocking email notifications')
    } finally {
      setTestEmailBusy(false)
    }
  }

  return <>
    <section className="settings">
      { user?.emailBlocked &&
        <div className="email-inactive-warning settings-group flex-col gap-3">
          <div className="flex-row gap-2 flex-align-center red">
            <WarningIcon/>
            <span className="bold red">Email Delivery Issue</span>
          </div>
          <div className="small">
            The last email that we sent to you, at {user.email}, was blocked or marked as spam. If you want to receive emails from us, tap the button below.
          </div>
          <div className="flex-row gap-2">
            <button
              className="button is-primary"
              onClick={sendTestEmail}
              disabled={testEmailBusy}
            >
              {testEmailBusy ? 'Unblocking and Sending Email...' : 'Unblock and Send Test Email'}
            </button>
          </div>
        </div>
      }

      <h4 className="p-1">Which emails do you want to receive?</h4>

      <div className="settings-group flex-col gap-1" ref={marketingRef}>
        <div className="spread">
          <label>
            Marketing
          </label>
          <Toggle checked={user?.wantsMarketingEmails || false} onChange={() => toggleNotification('marketing')}/>
        </div>
        <div className="small gray">
          Tips, news, and special offers.
        </div>
      </div>

      <div className="settings-group flex-col gap-1" ref={statusRef}>
        <div className="spread">
          <label>
            Upcoming Posts
          </label>
          <Toggle checked={user?.wantsStatusEmails || false} onChange={() => toggleNotification('status')}/>
        </div>
        <div className="small gray">
          Get an email each Wednesday, with a list of posts that will be published next week.
        </div>
      </div>
    </section>

    <style jsx>{`
      section {
        margin: 1rem 0;
        padding: 0 1rem;
        padding-bottom: 12rem;
      }

      .email-inactive-warning {
        background: #fdf2f2;
        border: 1px solid #ffc2c2;
        border-radius: 6px;
        padding: 1rem;
        margin-bottom: 1rem;
      }

    `}</style>
  </>
}
